/** Binary-search candle index by time (seconds). Kept dependency-free for drawing.base init. */
export const getTimeIndex = (data: any[], timeInSeconds: number) => {
    let left = 0
    let right = data.length - 1
    if (!data.length) return NaN

    const last = data[data.length - 1]
    const first = data[0]
    if ((last?.time ?? 0) < timeInSeconds) return data.length - 1
    if (timeInSeconds < first.time) return NaN
    while (true) {
        const mid = Math.floor((left + right) / 2)
        if (left == right) {
            return left
        } else if (left == mid) {
            if (data[right].time as number === timeInSeconds) {
                return right
            } else {
                return left
            }
        }
        const midCandle = data[mid]
        if (!midCandle) console.log('chart: mid candle', data, mid)
        if ((midCandle.time as number) == timeInSeconds) {
            return mid
        } else if ((midCandle.time as number) < timeInSeconds) {
            left = mid
        } else {
            right = mid
        }
    }
}
